import {TenantResource} from "client/resources";
import { TenantMissingVariableResource } from "../../client/resources/tenantMissingVariablesResource";

const TenantActions = {
    TENANT_FETCHED: "TENANT_FETCHED",
    TENANT_SAVED: "TENANT_SAVED",
    TENANT_VARIABLES_FETCHED: "TENANT_VARIABLES_FETCHED",
};

export interface TenantsAreaState {
    currentTenant: TenantState;
}

export interface TenantState {
    name: string;
    logoUrl: string;
    id: string;
    hasMissingVariables: boolean;
}

export function tenantFetched(tenant: TenantResource) {
    return { type: TenantActions.TENANT_FETCHED, tenant};
}

export function tenantSaved(tenant: TenantResource) {
    return { type: TenantActions.TENANT_SAVED, tenant};
}

export function tenantMissingVariablesFetched(tenantMissingVariables: TenantMissingVariableResource) {
    return {
        type: TenantActions.TENANT_VARIABLES_FETCHED,
        hasMissingVariables: !!tenantMissingVariables
    };
}

const tenantsArea = (state: TenantsAreaState = {currentTenant: null}, action: any): TenantsAreaState => {
    switch (action.type) {
        case TenantActions.TENANT_SAVED:
        case TenantActions.TENANT_FETCHED:
            const tenant = action.tenant as TenantResource;
            return {
                currentTenant: {
                    name: tenant.Name,
                    logoUrl: tenant.Links.Logo,
                    id: tenant.Id,
                    hasMissingVariables: false
                }
            };
        case TenantActions.TENANT_VARIABLES_FETCHED:
            return {
                currentTenant: {
                    ...state.currentTenant,
                    hasMissingVariables: action.hasMissingVariables}
            };
        default:
            return state;
    }
};

export default tenantsArea;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/tenants/tenantsArea.ts